module.exports = __webpack_public_path__ + "media/images/version_merge/appstore_btn-7eecfa9918235f98871900471171e858.svg";